import { render } from "./QRCodeMobileSignature.vue?vue&type=template&id=e7cf5e48"
import script from "./QRCodeMobileSignature.vue?vue&type=script&lang=js"
export * from "./QRCodeMobileSignature.vue?vue&type=script&lang=js"
script.render = render

export default script